import React from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../context/ProductContext';
import ProductCard from '../components/ProductCard';


const HomePage = () => {
  const { products, loading } = useProducts();
  const featuredProducts = products.filter(p => p.featured).slice(0, 5);

  return (
    <div className="bg-white min-h-screen">
      <section className="relative bg-[#8e0707] min-h-[500px] md:aspect-[1459/853] md:min-h-0">
        <div className="relative z-10 flex flex-col items-center justify-center px-4 py-12 md:px-8 md:py-32 text-center">
          <h1 className="text-3xl md:text-6xl font-medium text-white mb-4 md:mb-6 leading-tight max-w-4xl">
            Homemade taste,
            <br />
            curated with love for you!
          </h1>

          <p className="max-w-xl text-base md:text-xl text-white/90 mb-6 md:mb-10 px-4">
            It all "started with a compliment" which we thrive to hear from the world.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 md:gap-6 items-center">
            <Link to="/products">
              <button className="bg-white text-[#004f44] hover:bg-white/90 px-6 py-3 md:px-8 md:py-4 text-base md:text-lg font-medium rounded-lg transition-all">
                Shop now
              </button>
            </Link>

            <Link to="/bulk-order" className="flex items-center gap-2 md:gap-3 text-white hover:opacity-80 transition-opacity">
              <span className="text-base md:text-lg">Be a partner</span>
              <span className="text-xl">→</span>
            </Link>
          </div>
        </div>

        <div className="absolute inset-0 z-0">
          <img src="/Home.svg" alt="Hero background" className="w-full h-full object-cover opacity-30 md:opacity-100" />
        </div>
      </section>

      {/* Products Section */}
      <section className="py-16 md:py-24 px-8 md:px-[140px]">
        <div className="flex flex-col md:flex-row items-start md:items-baseline justify-between mb-12 gap-4">
          <h2 className="text-3xl md:text-4xl font-bold">
            <span className="text-[#272727]">Make every day meal, </span>
            <span className="text-[#8e0707]">DELICIOUS😋</span>
          </h2>
          <Link to="/products" className="text-[#8e0707] text-lg md:text-xl underline hover:opacity-70">
            view all
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {loading ? (
            <p>Loading...</p>
          ) : (
            featuredProducts.map(product => (
              <ProductCard key={product._id} product={product} />
            ))
          )}
        </div>
      </section>

      <section className="py-8 px-8 md:px-[140px] bg-[#f8f8f8]">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center">
          <p className="text-[#272727]">
            Ask for help, support, queries, or compliment here!
          </p>
          <a href="tel:+916263957789" className="rounded-full border border-[#272727] text-[#272727] px-6 py-2 hover:bg-[#272727] hover:text-white transition-all">
            +91 6263957789
          </a>
        </div>
      </section>
    </div>
  );
};

export default HomePage;